export function makeid(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const newId = (block) => {
  block.id = makeid(16);

  block.children.forEach((b) => {
    newId(b);
  });

  return block;
};

export const insert = (tree, block, path, after) => {
  const _block = JSON.parse(JSON.stringify(block));
  const _tree = JSON.parse(JSON.stringify(tree));
  let delta = 0;
  if (after) {
    delta = 1;
  }
  const __block = _block;
  let holder = _tree;
  path.forEach((x, i) => {
    if (i < path.length - 1) {
      holder = holder.children[x];
    }
  });
  holder.children.splice(path[path.length - 1] + delta, 0, __block);
  return _tree;
};

export const replace = (tree, block, path) => {
  const _block = JSON.parse(JSON.stringify(block));
  const _tree = JSON.parse(JSON.stringify(tree));
  if (path.length === 0) {
    return _block;
  }
  let holder = _tree;
  path.forEach((x, i) => {
    if (i < path.length - 1) {
      holder = holder.children[x];
    }
  });
  holder.children.splice(path[path.length - 1], 1, _block);
  return _tree;
};

export const remove = (tree, path) => {
  const _tree = JSON.parse(JSON.stringify(tree));
  let holder = _tree;
  path.forEach((x, i) => {
    if (i < path.length - 1) {
      holder = holder.children[x];
    }
  });
  holder.children.splice(path[path.length - 1], 1);
  return _tree;
};

export const move = (tree, block, fromPath, toPath, after) => {
  const shortIndex =
    fromPath.length < toPath.length ? fromPath.length - 1 : toPath.length - 1;
  const dragUp = fromPath[shortIndex] >= toPath[shortIndex];
  const _block = Object.assign({}, { ...block });
  const _tree = JSON.parse(JSON.stringify(tree));
  if (dragUp) {
    //remove then insert
    const __tree = remove(_tree, fromPath);
    const ___tree = insert(__tree, _block, toPath, after);
    return ___tree;
  } else {
    //insert then remove
    const __tree = insert(_tree, _block, toPath, after);
    const ___tree = remove(__tree, fromPath);
    return ___tree;
  }
};
